import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopMobileAccessories = dynamic(() => import('../../components/electronics/mobile-accessories/DesktopMobileAcc'), {
  loading: () => <Loading />,

});
const MobileMobileAccessories = dynamic(() => import('../../components/electronics/mobile-accessories/MobileMobileAcc'), {
  loading: () => <Loading />,

});
const mobileAccessories = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Mobile Shop Billing Software with POS & Inventory Management</title>
        <link rel="canonical" href="https://queuebuster.co/electronics/mobile-accessories-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/electronics/mobile-accessories-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Streamline your mobile and accessories shop with cutting-edge billing software featuring POS and inventory management software with QueueBuster. Get a Free Demo." />
        <meta property="og:title" content="Mobile Shop Billing Software with POS & Inventory Management By QueueBuster POS" />
        <meta property="og:description" content="Streamline your mobile and accessories shop with cutting-edge billing software featuring POS and inventory management. Simplify POS operations and inventory control effortlessly. Get a Free Demo" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/mobile-accessories.jpg" />
        <meta property="og:url" content="https://queuebuster.co/electronics/mobile-accessories-pos-billing-software" />
      </Head>
         <SchemaTags page="mobile-accessories-pos-billing-software" />
      {mobileView ? <MobileMobileAccessories /> : <DesktopMobileAccessories />}
    </>
  )
}

export default mobileAccessories